import { render, staticRenderFns } from "./TodayOrder.vue?vue&type=template&id=4f86e0b7&scoped=true"
import script from "./TodayOrder.vue?vue&type=script&lang=js"
export * from "./TodayOrder.vue?vue&type=script&lang=js"
import style0 from "./TodayOrder.vue?vue&type=style&index=0&id=4f86e0b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f86e0b7",
  null
  
)

export default component.exports